import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import CrmComWhatsapp from "@/pages/CrmComWhatsapp";

export const Route = createFileRoute("/crm-com-whatsapp")({
  head: () => buildHead({
    title: "CRM com WhatsApp e Instagram integrados: o funil que se move sozinho | OP2P",
    description: "CRM com WhatsApp e Instagram integrados: a IA acompanha cada oportunidade do primeiro contato à venda. Veja como funciona.",
    path: "/crm-com-whatsapp",
  }),
  component: CrmComWhatsapp,
});
